import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";

export default function GoogleAuth() {
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();

  // ✅ Read plan from URL (starter / pro / null)
  const plan = searchParams.get("plan");

  const API_URL = process.env.REACT_APP_API_URL || "";
  const handleGoogleLogin = () => {
    if (!API_URL) {
      alert("App misconfigured. Please contact support.");
      return;
    }

    setLoading(true);

    let url = `${API_URL}/google?app=blogslicer`;
    if (plan) {
      url += `&plan=${plan}`;
    }

    window.location.href = url;
  };

  return (
    <div className="min-h-screen flex">
      {/* Left */}
      <div className="flex flex-1 flex-col justify-center px-6 lg:px-20">
        <div className="mx-auto w-full max-w-sm space-y-8">
          {/* Logo / Title */}
          <div>
            <h1 className="text-3xl font-bold text-gray-900">BlogSlicer</h1>
            <p className="mt-2 text-gray-500">
              Turn blogs & long videos into viral content.
            </p>
          </div>

          {/* Google CTA */}
          <button
            onClick={handleGoogleLogin}
            disabled={loading}
            className="w-full flex items-center justify-center gap-3 rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-semibold text-gray-700 shadow-sm hover:bg-gray-50 transition disabled:opacity-50"
          >
            <img
              src="https://www.svgrepo.com/show/475656/google-color.svg"
              alt="Google"
              className="h-5 w-5"
            />
            {loading ? "Redirecting…" : "Continue with Google"}
          </button>

          {/* Helper text */}
          <p className="text-xs text-gray-400 text-center">
            {plan
              ? `You selected the ${plan} plan · You’ll be asked to pay after login`
              : "We’ll create an account if you’re new · No credit card required"}
          </p>
        </div>
      </div>

      {/* Right Image */}
      <div className="relative hidden w-0 flex-1 lg:block">
        <img
          alt="Creator workspace"
          src="https://images.unsplash.com/photo-1496917756835-20cb06e75b4e"
          className="absolute inset-0 h-full w-full object-cover"
        />
      </div>
    </div>
  );
}
